import authAxios from '@services/authAxios';

const exportSellout = async (queries) => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/sellout/data/download?${queries}`,
        responseType: 'blob',
    });

    return data;
};

export default exportSellout;
